import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "breadcrumb-label" }
const _hoisted_4 = {
  key: 1,
  class: "breadcrumb-item breadcrumb-item-current"
}
const _hoisted_5 = { class: "breadcrumb-label" }

import { Icon } from "@iconify/vue";
import { useRouter } from "vue-router";

interface BreadcrumbItem {
  label: string;
  route?: string | { name: string; params?: Record<string, any> };
  icon?: string;
  clickable?: boolean;
  onClick?: () => void;
}

interface Props {
  items: BreadcrumbItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();

const handleItemClick = (item: BreadcrumbItem) => {
  if (item.onClick) {
    item.onClick();
  } else if (item.route) {
    if (typeof item.route === "string") {
      router.push(item.route);
    } else {
      router.push(item.route);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (item.clickable !== false && (item.route || item.onClick))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "breadcrumb-item",
              onClick: ($event: any) => (handleItemClick(item))
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
            ], 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
            ])),
        (index < __props.items.length - 1)
          ? (_openBlock(), _createBlock(_unref(Icon), {
              key: 2,
              icon: "mdi:chevron-right",
              class: "breadcrumb-separator"
            }))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})